import React from "react";
import apstyles from '../styles/app.module.css';
import videoPlayer from "./VideoPlayer";

function VideoPoster({togglerStatus, setVideoToPlay, setIsModal, videoToPlay}) {
    const items = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36];

    const initialPath = togglerStatus === "female" ? "/f/" : "/m/";
     const posterpath = "/files/public/ervideos/poster";

  const handleVideoToPlay = (item) =>

    {

        setVideoToPlay({ videoid: item, videopath: initialPath });

        setIsModal(true);

    }


    return (
        <section className={apstyles.posterliste}>
            {
                items.map((item) => (
                    <section key={item} className={apstyles.posteritem}>
                        <img src={`${posterpath}${initialPath}${item}.jpg`} alt="" loading="lazy"
                        onClick={

                            ()=>handleVideoToPlay(item)
                        }


                        />
                    </section>
                ))
            }
        </section>
    );
}

export default VideoPoster;
